"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "@/components/ui/Link";
import { useRouter } from "next/navigation";
import { MessageIcon } from "../ui/message-icon";
import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getTimeAgo, getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';
type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};
type Props = {
  category?: FieldConfig;
  sectionUrl?: string;
  title?: FieldConfig;
  excerpt?: FieldConfig;
  timeAgo?: FieldConfig;
  imageSrc?: FieldConfig;
  slug?: string;
  /** Mark as LCP image - preloads for faster rendering */
  priority?: boolean;
  imageMetadata?: ImageMetadata;
};
export default function HorizontalBigImageAuthorNews(t0) {
  const $ = _c(52);
  const {
    category: t1,
    title: t2,
    excerpt: t3,
    timeAgo: t4,
    imageSrc: t5,
    slug,
    priority: t6,
    imageMetadata
  } = t0;
  const category = t1 === undefined ? {
    hidden: false,
    value: "INDIA",
    customClass: ""
  } : t1;
  let t7;
  if ($[0] !== t2) {
    t7 = t2 === undefined ? {
      hidden: false,
      value: "\u0B87\u0BA8\u0BCD\u0BA4\u0BBF\u0BAF\u0BBE\u0BB5\u0BBF\u0BA9\u0BCD \u0BA8\u0BBF\u0BB2\u0B95\u0BCD\u0B95\u0BB0\u0BBF \u0B89\u0BB1\u0BCD\u0BAA\u0BA4\u0BCD\u0BA4\u0BBF 8.5 \u0B9A\u0BA4\u0BB5\u0BC0\u0BA4\u0BAE\u0BCD \u0B85\u0BA4\u0BBF\u0B95\u0BB0\u0BBF\u0BAA\u0BCD\u0BAA\u0BC1; \u0BA8\u0BBF\u0BB2\u0B95\u0BCD\u0B95\u0BB0\u0BBF \u0B85\u0BAE\u0BC8\u0B9A\u0BCD\u0B9A\u0B95\u0BAE\u0BCD",
      customClass: ""
    } : t2;
    $[0] = t2;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const title = t7;
  let t8;
  if ($[2] !== t3) {
    t8 = t3 === undefined ? {
      hidden: false,
      value: "\u0BA8\u0BBE\u0B9F\u0BCD\u0B9F\u0BBF\u0BA9\u0BCD \u0BA8\u0BBF\u0BB2\u0B95\u0BCD\u0B95\u0BB0\u0BBF \u0B89\u0BB1\u0BCD\u0BAA\u0BA4\u0BCD\u0BA4\u0BBF 2023 \u0B8F\u0BAA\u0BCD\u0BB0\u0BB2\u0BBF\u0BB2\u0BCD 8.5 \u0B9A\u0BA4\u0BB5\u0BC0\u0BA4\u0BAE\u0BCD \u0B85\u0BA4\u0BBF\u0B95\u0BB0\u0BBF\u0BA4\u0BCD\u0BA4\u0BC1 73.14 \u0B95\u0BCB\u0B9F\u0BBF \u0B9F\u0BA9\u0BCD\u0BA9\u0BBE\u0B95",
      customClass: ""
    } : t3;
    $[2] = t3;
    $[3] = t8;
  } else {
    t8 = $[3];
  }
  const excerpt = t8;
  let t9;
  if ($[4] !== t4) {
    t9 = t4 === undefined ? {
      hidden: false,
      value: "15 min ago",
      customClass: ""
    } : t4;
    $[4] = t4;
    $[5] = t9;
  } else {
    t9 = $[5];
  }
  const timeAgo = t9;
  let t10;
  if ($[6] !== t5) {
    t10 = t5 === undefined ? {
      hidden: false,
      value: FALLBACK_IMAGE,
      customClass: ""
    } : t5;
    $[6] = t5;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  const imageSrc = t10;
  const priority = t6 === undefined ? false : t6;
  useRouter();
  const titleValue = title?.value || "";
  const excerptValue = excerpt?.value || "";
  let t11;
  if ($[8] !== imageSrc?.value) {
    t11 = getImageUrl(imageSrc?.value) || FALLBACK_IMAGE;
    $[8] = imageSrc?.value;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  const imageSrcValue = t11;
  category?.value || "";
  const t12 = timeAgo?.value;
  let t13;
  if ($[10] !== t12) {
    t13 = getTimeAgo(t12);
    $[10] = t12;
    $[11] = t13;
  } else {
    t13 = $[11];
  }
  const timeAgoValue = t13;
  let t14;
  if ($[12] !== imageMetadata || $[13] !== imageSrc?.customClass || $[14] !== imageSrc?.hidden || $[15] !== imageSrcValue || $[16] !== priority || $[17] !== titleValue) {
    t14 = !imageSrc?.hidden && <div className={`${imageSrc?.customClass || ""}`}><div className="relative w-[106px] h-[76px] md:w-[125px] md:h-[125px] flex-shrink-0 overflow-hidden"><Image src={imageSrcValue} alt={titleValue} fill={true} priority={priority} sizes="(max-width: 768px) 100px, 125px" className="object-cover w-full h-full" style={getFocusPointStyle(imageMetadata)} loading={priority ? "eager" : "lazy"} fetchPriority={priority ? "high" : "auto"} placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} /></div></div>;
    $[12] = imageMetadata;
    $[13] = imageSrc?.customClass;
    $[14] = imageSrc?.hidden;
    $[15] = imageSrcValue;
    $[16] = priority;
    $[17] = titleValue;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] !== title?.customClass || $[20] !== title?.hidden || $[21] !== titleValue) {
    t15 = !title?.hidden && <h3 className={`text-14-tamil-700 text-1B1B1B leading-[1.4] ${title?.customClass || ""}`}>{titleValue}</h3>;
    $[19] = title?.customClass;
    $[20] = title?.hidden;
    $[21] = titleValue;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== excerpt?.customClass || $[24] !== excerpt?.hidden || $[25] !== excerptValue) {
    t16 = !excerpt?.hidden && <p className={`text-12-tamil-400 text-4D4D4D leading-[1.4] line-clamp-2 ${excerpt?.customClass || ""}`}>{excerptValue}</p>;
    $[23] = excerpt?.customClass;
    $[24] = excerpt?.hidden;
    $[25] = excerptValue;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t15 || $[28] !== t16) {
    t17 = <div className="flex flex-col gap-2">{t15}{t16}</div>;
    $[27] = t15;
    $[28] = t16;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== timeAgo?.customClass || $[31] !== timeAgo?.hidden || $[32] !== timeAgoValue) {
    t18 = !timeAgo?.hidden && <span className={`text-12-english-500 text-1B1B1B ${timeAgo?.customClass || ""}`}>{timeAgoValue}</span>;
    $[30] = timeAgo?.customClass;
    $[31] = timeAgo?.hidden;
    $[32] = timeAgoValue;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  const t19 = slug ? `/${slug}` : undefined;
  let t20;
  if ($[34] !== excerptValue || $[35] !== imageSrcValue || $[36] !== slug || $[37] !== t19 || $[38] !== titleValue) {
    t20 = <MessageIcon id="image-news-message-icon" slug={slug} category={BOOKMARK_CATEGORIES.NEWS} title={titleValue} thumbnailUrl={imageSrcValue} description={excerptValue} articleUrl={t19} />;
    $[34] = excerptValue;
    $[35] = imageSrcValue;
    $[36] = slug;
    $[37] = t19;
    $[38] = titleValue;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== t18 || $[41] !== t20) {
    t21 = <div className="mt-2"><div className="flex items-center justify-between">{t18}{t20}</div></div>;
    $[40] = t18;
    $[41] = t20;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  let t22;
  if ($[43] !== t17 || $[44] !== t21) {
    t22 = <div className="flex flex-col justify-between md:min-h-[125px] w-full">{t17}{t21}</div>;
    $[43] = t17;
    $[44] = t21;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  let t23;
  if ($[46] !== t14 || $[47] !== t22) {
    t23 = <article className="bg-F8F8F8 overflow-hidden p-4 mb-0"><div className="flex gap-4">{t14}{t22}</div></article>;
    $[46] = t14;
    $[47] = t22;
    $[48] = t23;
  } else {
    t23 = $[48];
  }
  const content = t23;
  if (slug) {
    const t24 = `/${slug}`;
    let t25;
    if ($[49] !== content || $[50] !== t24) {
      t25 = <Link href={t24} className="block  transition-colors cursor-pointer">{content}</Link>;
      $[49] = content;
      $[50] = t24;
      $[51] = t25;
    } else {
      t25 = $[51];
    }
    return t25;
  }
  return content;
}